__turbopack_context__.v({
  "accordionWrapper": "yHZX3q_accordionWrapper",
  "faqFeedback": "yHZX3q_faqFeedback",
  "loadMoreContainer": "yHZX3q_loadMoreContainer",
  "tags": "yHZX3q_tags",
  "title": "yHZX3q_title",
  "topContent": "yHZX3q_topContent",
});
